import { IChildProp } from "@intelligence/components/Form/type";
import { TDataSource, TDataSourceMetrics, convertDataSourceAndSource } from "@intelligence/_config/enumeration/dataSource";

const CONSOLE_DATA_SOURCE: Record<TDataSource, TDataSourceMetrics[]> = {
  mscience: ['digitalRevenue', 'units', 'digitalARPPU', 'ast', 'mscienceLifetimeDigitalRevenue', 'mscienceLifetimeDigitalUnits'],
  databrain: [
    'databrain__total_revenue',
    'databrain__lifetime_total_revenue',
    'databrain__base_game_sales_units',
    'databrain__lifetime_base_game_sales_units',
  ],
  gsd: ['digitalUnitsGSD', 'physicalUnitsGSD', 'digitalRevenueGSD', 'physicalRevenueGSD'],
  npd: ['physicalRevenue', 'physicalUnits'],
  newzoo: ['mau', 'playerShare', 'mauGrowth', 'mauNew', 'mauReturning', 'lifetimePlayer', 'timeSpent0h','timeSpent1h', 'timeSpent5h', 'timeSpent10h', 'timeSpent25h', 'timeSpent50h', 'avgDailyPlaytime', 'avgDailySessions', 'avgPlaytimePerSession', 'avgMonthlyPlaytime', 'avgMonthlySessions', 'avgDaysPlayed', 'stickness', 'totalHours', 'churn', 'acquisition', 'retentionD1', 'retentionD2', 'retentionD4', 'retentionD7', 'retentionD14', 'retentionD28'],
  hatchet: ['hoursWatched', 'airtime', 'peakCCV', 'avgCCV'],
  // Famitsu is temporarily unavailable in Intelligence pages.
  // famitsu: ['famitsu_salesOfSelectedTime', 'famitsu_revenueOfSelectedTime', 'famitsu_cumulativeSales', 'famitsu_cumulativeRevenueFamitsu', 'famitsu_priceFamitsu'],
};

const getMetricsChildren = () => convertDataSourceAndSource(CONSOLE_DATA_SOURCE, {
  disableCondition: {
    gsd: 'additionalFields:dateType:daily||additionalFields:dateType:monthly',
    hatchet: '!additionalFields:region:global',
    npd: 'additionalFields:dateType:daily||additionalFields:dateType:weekly',
    // Famitsu is temporarily unavailable in Intelligence pages.
    // famitsu: 'additionalFields:dateType:daily||additionalFields:dateType:monthly',
    newzoo: 'additionalFields:dateType:daily||additionalFields:dateType:weekly',
  },
  disableMsgKey: {
    gsd: 'dbi_info_gsd_metrics_category_disabled_tips',
    hatchet: 'dbi_info_only_global_data',
    npd: 'dbi_info_physical_monthly_only',
    // Famitsu is temporarily unavailable in Intelligence pages.
    // famitsu: 'dbi_info_console_japan_sales_metrics_category_disabled_tips',
    newzoo: 'dbi_info_newzoo_bymonth',
  },
  // 默认权限，convertDataSourceAndSource会过滤禁选的选项
  isDefault: {
    mscience: 'all',
    databrain: 'all',
    gsd: 'all',
    npd: 'all',
    newzoo: 'all',
    hatchet: 'all',
    // Famitsu is temporarily unavailable in Intelligence pages.
    // famitsu: 'all',
  },
});

const CONSOLE_DETAIL_STATS_DOWNLOAD_SET: IChildProp[] =
  [{
    enumKey: 'mutilMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'cascader',
    children: getMetricsChildren(),
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRegion',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'platformSettingsNPD',
      enumTargetType: 'downloadMainCategory',
      type: 'checkboxGroup',
      disableCondition: 'additionalFields:dateType:weekly||additionalFields:dateType:daily',
      children: [{
        isDefault: true,
        enumKey: 'playStation4',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'playStation5',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'xboxOne',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'xboxSeriesxs',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'nintendoWiiU',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'nintendoSwitch',
        enumTargetType: 'platformPC',
      }]
    }, {
      enumKey: 'platformSettingsGSD',
      enumTargetType: 'downloadMainCategory',
      type: 'checkboxGroup',
      disableCondition: 'additionalFields:dateType:daily||additionalFields:dateType:monthly',
      children: [{
        isDefault: true,
        enumKey: 'playStation4',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'playStation5',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'xboxOne',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'xboxSeriesxs',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'nintendoWiiU',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'nintendoSwitch',
        enumTargetType: 'platformPC',
      }]
    }, {
      enumKey: 'platformSettingsMscience',
      enumTargetType: 'downloadMainCategory',
      type: 'checkboxGroup',
      children: [{
        isDefault: true,
        enumKey: 'playstation',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'xbox',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'nintendo',
        enumTargetType: 'platformPC',
      }]
    }, {
      enumKey: 'platformSettingsFamitsu',
      enumTargetType: 'downloadMainCategory',
      disableCondition: 'additionalFields:dateType:daily||additionalFields:dateType:monthly',
      type: 'checkboxGroup',
      children: [{
        isDefault: true,
        enumKey: 'ps5',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'ps4',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'switch',
        enumTargetType: 'platformPC',
      }]
    }, {
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        isDefault: true,
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByCountries',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByRegion',
        enumTargetType: 'downloadDataCalcu',
      }]
    }],
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

const CONSOLE_DETAIL_STATS_JAPAN_SALES_DOWNLOAD_SET: IChildProp[] =
  [{
    enumKey: 'mutilMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'cascader',
    children: getMetricsChildren(),
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRegion',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [
      // Japan Sales只有周粒度数据，跟苏桐沟通可以暂时隐藏 24.12.30
      // {
      //   label: 'Platform Settings(NPD)',
      //   labelKey: 'dbi_label_npd_device_settings',
      //   value: 'npd',
      //   type: 'checkboxGroup',
      //   disableCondition: 'additionalFields:dateType:weekly',
      //   children: [{
      //     isDefault: true,
      //     label: 'PlayStation 4',
      //     value: 'PlayStation 4'
      //   }, {
      //     isDefault: true,
      //     label: 'PlayStation 5',
      //     value: 'PlayStation 5',
      //   }, {
      //     isDefault: true,
      //     label: 'Xbox One',
      //     value: 'Xbox One',
      //   }, {
      //     isDefault: true,
      //     label: 'Xbox Series X|S',
      //     value: 'Xbox Series X|S'
      //   }, {
      //     isDefault: true,
      //     label: 'Nintendo Wii U',
      //     value: 'Nintendo Wii U',
      //   }, {
      //     isDefault: true,
      //     label: 'Nintendo Switch',
      //     value: 'Nintendo Switch',
      //   }]
      // },
      {
        enumKey: 'platformSettingsGSD',
        enumTargetType: 'downloadMainCategory',
        type: 'checkboxGroup',
        children: [{
          isDefault: true,
          enumKey: 'playStation4',
          enumTargetType: 'platformPC',
        }, {
          isDefault: true,
          enumKey: 'playStation5',
          enumTargetType: 'platformPC',
        }, {
          isDefault: true,
          enumKey: 'xboxOne',
          enumTargetType: 'platformPC',
        }, {
          isDefault: true,
          enumKey: 'xboxSeriesxs',
          enumTargetType: 'platformPC',
        }, {
          isDefault: true,
          // 注意GSD的值不一样
          enumKey: 'wiiU',
          enumTargetType: 'platformPC',
        }, {
          isDefault: true,
          enumKey: 'nintendoSwitch',
          enumTargetType: 'platformPC',
        }]
      }, {
        enumKey: 'platformSettingsMscience',
        enumTargetType: 'downloadMainCategory',
        type: 'checkboxGroup',
        children: [{
          isDefault: true,
          enumKey: 'playstation',
          enumTargetType: 'platformPC',
        }, {
          isDefault: true,
          enumKey: 'xbox',
          enumTargetType: 'platformPC',
        }, {
          isDefault: true,
          enumKey: 'nintendo',
          enumTargetType: 'platformPC',
        }]
      }, {
        enumKey: 'platformSettingsFamitsu',
        enumTargetType: 'downloadMainCategory',
        type: 'checkboxGroup',
        children: [{
          isDefault: true,
          enumKey: 'ps5',
          enumTargetType: 'platformPC',
        }, {
          isDefault: true,
          enumKey: 'ps4',
          enumTargetType: 'platformPC',
        }, {
          isDefault: true,
          enumKey: 'switch',
          enumTargetType: 'platformPC',
        }]
      }, {
        enumKey: 'timeSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'radio',
        children: [{
          enumKey: 'isTimeAggregated',
          enumTargetType: 'downloadDataCalcu',
        }, {
          isDefault: true,
          enumKey: 'isSeparateByTime',
          enumTargetType: 'downloadDataCalcu',
        }]
      }, {
        enumKey: 'regionSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'text',
        children: [{
          enumKey: 'isCountryAggregated',
          enumTargetType: 'downloadDataCalcu',
        }],
      },
    ],
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

const CONSOLE_DETAIL_STORE_RANK_DOWNLOAD_SET: IChildProp[] = [{
  enumKey: 'dataSettings',
  enumTargetType: 'downloadMainCategory',
  type: 'checkboxGroup',
  children: [{
    isDefault: true,
    enumKey: 'playstationStoreRank',
    enumTargetType: 'platformPC',
  }, {
    enumKey: 'xboxStoreRank',
    enumTargetType: 'platformPC',
  }, {
    enumKey: 'nintendoStoreRank',
    enumTargetType: 'platformPC',
  }]
}, {
  enumKey: 'basicInformation',
  enumTargetType: 'downloadMainCategory',
  type: 'checkboxGroup',
  children: [{
    enumKey: 'hasCompany',
    enumTargetType: 'downloadBasicInfo',
  }, {
    enumKey: 'hasGenre',
    enumTargetType: 'downloadBasicInfo',
  }, {
    enumKey: 'hasRelease',
    enumTargetType: 'downloadBasicInfo',
  }, {
    enumKey: 'hasRegion',
    enumTargetType: 'downloadBasicInfo',
  }],
}, {
  enumKey: 'dataCalculation',
  enumTargetType: 'downloadMainCategory',
  type: 'subForm',
  className: 'form-item--top-18',
  children: [
    {
      enumKey: 'dateSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'text',
      children: [{
        isDefault: true,
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByCountries',
        enumTargetType: 'downloadDataCalcu',
      }]
    },
  ],
}, {
  enumKey: 'fileFormat',
  enumTargetType: 'downloadMainCategory',
  type: 'radio',
  children: [{
    isDefault: true,
    enumKey: 'exportExcel',
    enumTargetType: 'downloadOther',
  }, {
    enumKey: 'exportCSV',
    enumTargetType: 'downloadOther',
  }],
}];

export default {
  consoleDetailStatsAndCountries: CONSOLE_DETAIL_STATS_DOWNLOAD_SET,
  consoleDetailJapanSales: CONSOLE_DETAIL_STATS_JAPAN_SALES_DOWNLOAD_SET,
  consoleDetailStoreRank: CONSOLE_DETAIL_STORE_RANK_DOWNLOAD_SET
};
